import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { ExpandablePanel, Title, TryAgainMessage } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import { useSportsAnimalRacingMeetingsWidget } from '../../model';
import Meeting from '../Meeting/Meeting';

import { TXTWCL_International, TXTWCL_UK_X_Ireland } from './MeetingGroups.messages.json';
import styles from './MeetingGroups.scss';

const groupMap = {
  ISP_I18N_UK_X_IRELAND: TXTWCL_UK_X_Ireland,
  ISP_I18N_INTERNATIONAL: TXTWCL_International
};

const numberOfInitiallyOpenPanels = 1;
const numberOfInitiallyOpenMeetings = 1;

const MeetingGroups: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  const { widgetSelect } = useSportsAnimalRacingMeetingsWidget();

  const templateGroups = useSelector(widgetSelect.templateGroups);

  if (!templateGroups.length) {
    return <TryAgainMessage />;
  }

  return (
    <>
      {templateGroups.map((meetingGroups, index) =>
        meetingGroups.map((meetingGroup, mgIndex) => (
          <div
            className={styles.wrapper}
            key={`group-${meetingGroup.name}-${mgIndex}`}
            data-testid="sports-meeting-group"
          >
            <ExpandablePanel
              isOpenInitially={
                index < numberOfInitiallyOpenPanels && mgIndex < numberOfInitiallyOpenPanels
              }
              title={
                <Title>
                  <FormattedDateTime
                    date={meetingGroup.date}
                    format="long"
                    weekday="long"
                    hideTime
                  />{' '}
                  - {formatMessage(groupMap[meetingGroup.name])}
                </Title>
              }
            >
              {meetingGroup.meetingIds.map((id, idx) => (
                <Meeting
                  key={`meeting-${id}`}
                  isOpen={idx < numberOfInitiallyOpenMeetings}
                  id={id}
                />
              ))}
            </ExpandablePanel>
          </div>
        ))
      )}
    </>
  );
};

export default MeetingGroups;
